export default {
  "header.hit": "Hit",
  "header.count": "hit",
  "form.keyword": "Keyword :",
  "form.category": "Category :",
  "form.category.all": "All",
  "form.category.select": "select category",
  "form.submit": "Search",
  "list.title": " ",
  "list.noResult": " No result matching",
  "tagSearch.list.title": " ",
  "tagSearch.eventStart.label": "Event Date",
} as const;
